// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
} from './';

export default {
  path: '/',
  name: 'Worker config',
  childRoutes: [
    { path: 'worker-config', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'worker-config/:id', name: 'Default page', component: DefaultPage, isIndex: false },
  ],
};



// WEBPACK FOOTER //
// ./src/features/worker-config/route.js